import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { usePmsDepartment, PmsDepartment } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<PmsDepartment>
    useData={usePmsDepartment}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
